import React from "react";
import DashboardContent from "./DashboardContent";
import Layout from '../../Layout';

function Inicio() {
    return (
        <Layout>
            <DashboardContent />
        </Layout>
    );
}

export default Inicio;